import React from 'react';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button, { ButtonVariant } from '../UI/V3/Button/Button';
import styles from './EmptyState.module.scss';

interface EmptyStateProps {
    icon: IconDefinition;
    title: string;
    description: string;
    buttonLabel?: string;
    buttonIcon?: IconDefinition;
    onButtonClick?: () => void;
    showButton?: boolean;
    buttonVariant?: ButtonVariant;
    buttonSize?: 'small' | 'medium' | 'large';
}

export const EmptyState: React.FC<EmptyStateProps> = ({
    icon,
    title,
    description,
    buttonLabel,
    buttonIcon,
    onButtonClick,
    showButton = false,
    buttonVariant = 'outlined',
    buttonSize = 'large'
}) => {
    return (
        <div className={styles.emptyState}>
            <div className={styles.iconContainer}>
                <FontAwesomeIcon
                    icon={icon}
                    className={styles.icon}
                />
            </div>

            <h2 className={styles.title}>{title}</h2>

            <p className={styles.description}>{description}</p>

            {showButton && buttonLabel && onButtonClick && (
                <div className={styles.action}>
                    <Button
                        leftIcon={buttonIcon}
                        label={buttonLabel}
                        onClick={onButtonClick}
                        variant={buttonVariant}
                        size={buttonSize}
                    />
                </div>
            )}
        </div>
    );
};

export default EmptyState;
